// Shared between the admin story moderation forms (learning-area picker)
// and the public Stories page (filter buttons, card footer label) so both
// stay in sync with a single source of truth.
export const storyCategories = [
  { value: "data", label: "Data" },
  { value: "product-design", label: "Product & Design" },
  { value: "business", label: "Business" },
  { value: "software-cloud", label: "Software & Cloud" },
];

export const getStoryCategory = (value) =>
  storyCategories.find((category) => category.value === value);
